import { useState, useEffect } from "react";
import {
  HiOutlineHome,
  HiOutlineUser,
  HiOutlineLogout,
  HiOutlineMenuAlt3,
  HiOutlineChevronLeft,
  HiOutlineChevronRight,
} from "react-icons/hi";
import {
  HiOutlineSparkles,
  HiOutlineClipboardDocumentList,
} from "react-icons/hi2";

import "./Sidebar.css";
import { useNavigate, useLocation } from "react-router-dom";
import authService from "../services/auth.service";
import { useSidebar } from "../context/SidebarContext";

const Sidebar = () => {
  const { isOpen, toggle } = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const handleNavClick = (path) => {
    navigate(path);
  };

  // 📱 Check if mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 📱 Handle click outside to close mobile sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        window.innerWidth <= 768 &&
        isOpen &&
        !event.target.closest(".sidebar") &&
        !event.target.closest(".mobile-menu-btn")
      ) {
        toggle();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, toggle]);

  const menuItems = [
    {
      path: "/app/activities",
      name: "Activities",
      icon: <HiOutlineHome />,
    },
    {
      path: "/app/actions-to-follow",
      name: "Actions to Follow",
      icon: <HiOutlineClipboardDocumentList />,
    },
    {
      path: "/app/agent",
      name: "My Agents",
      icon: <HiOutlineSparkles />,
    },
  ];

  // Normalize path for matching
  const normalizePath = (path) => {
    if (path === "/app" || path === "/app/") return "/app/activities";
    return path.replace(/\/+$/, "");
  };

  const isActive = (path) => {
    const current = normalizePath(location.pathname);
    const target = normalizePath(path);

    return current === target || current.startsWith(target + "/");
  };

  return (
    <>
      {/* Mobile Menu Button - Only visible on mobile when sidebar is hidden */}
      {isMobile && !isOpen && (
        <button className="mobile-menu-btn" onClick={toggle}>
          <HiOutlineMenuAlt3 />
        </button>
      )}

      {/* ---- SIDEBAR ---- */}
      <div className={`sidebar ${isOpen ? "expanded" : "collapsed"}`}>
        {/* ---- TOP SECTION ---- */}
        <div className="top_section">
          {isOpen && <div className="logo">Sitepilot</div>}

          {/* Sidebar Toggle Button */}
          <div className="sidebar-toggle-container">
            <button
              className="sidebar-toggle-btn"
              onClick={toggle}
              title={isOpen ? "Collapse sidebar" : "Expand sidebar"}
            >
              {isOpen ? <HiOutlineChevronLeft /> : <HiOutlineChevronRight />}
            </button>
          </div>
        </div>

        {/* ---- MAIN MENU ---- */}
        <div className="menu_section">
          <div className="organized-menu">
            {menuItems.map((item, index) => (
              <div
                key={index}
                className={`link ${isActive(item.path) ? "active" : ""}`}
                onClick={() => handleNavClick(item.path)}
              >
                <div className="icon">{item.icon}</div>
                <div className="link_text">{item.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ---- BOTTOM SECTION ---- */}
        <div className="bottom_section">
          <div
            className={`link logoutLink ${
              location.pathname === "/app/profile" ? "active" : ""
            }`}
            onClick={() => handleNavClick("/app/profile")}
          >
            <div className="icon">
              <HiOutlineUser />
            </div>
            {isOpen && <div className="link_text">Profile</div>}
          </div>
          <div className="link logoutLink" onClick={handleLogout}>
            <div className="icon">
              <HiOutlineLogout />
            </div>
            {isOpen && <div className="link_text">Logout</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
